import { useLocation } from "react-router-dom";

const useQueryParams = (): any => {
  return new URLSearchParams(useLocation().search);
};

export default useQueryParams;
